import { Component, ViewChild } from '@angular/core';
import { NavParams, ViewController, PopoverController, Events } from 'ionic-angular';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';

/**
 * Generated class for the CoGuestRegisterInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-guest-register-input',
  templateUrl: 'co-guest-register-input.html'
})
export class CoGuestRegisterInputComponent {

  text: string;
  eventAges: Array<any>;
  showAges: boolean;
  areFieldsValid: {firstName: boolean, lastName: boolean, age: boolean} = {firstName: true, lastName: true, age: true}
  pleaseCheckInputs: boolean = false;
  guestInput: {firstName: string, lastName: string, age: string} = {firstName: null, lastName: null, age: ''};
  @ViewChild('firstName') firstName;
  constructor(public navParams : NavParams, public viewCtrl: ViewController, popoverCtrl: PopoverController, private events : Events, private timeout : TimeoutFunctionsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.eventAges = this.navParams.data.ages;
    this.showAges = this.navParams.data.settings.events_age_enabled;
  }

  ionViewDidLoad(){
    setTimeout(() => {
      this.firstName.setFocus();
    },1000);
  }

  addGuest(){
    this.validateFields().then(res =>{
      if (res) {
        this.pleaseCheckInputs = false;
        if (this.guestInput.age === ''){
          this.guestInput.age = null;
        }
        this.close();
      } else {
        this.pleaseCheckInputs = true;
      }
    })
  }

  close(){
    this.viewCtrl.dismiss({info: this.guestInput});
  }

  async validateFields(){
    let counter = 0
    for (var key in this.guestInput){
      if (this.guestInput[key] === null) {
        this.areFieldsValid[key] = false;
        counter++
      } else {
        this.areFieldsValid[key] = true;
      }
    };
    // if (this.guestInput.age === 'INITIAL'){
    //   this.areFieldsValid.age = false;
    //   counter++;
    // }


    return counter <= 0;
  }


  chooseAgeGroup(event){
    this.guestInput.age = event.target.value;
  }


}



// WEBPACK FOOTER //
// ./src/components/co-guest-register-input/co-guest-register-input.ts